import { useState } from "react";
import { Send } from "lucide-react";

const MessageInput = ({
  onSendMessage,
  placeholder = "Type a message...",
  disabled = false,
}) => {
  const [message, setMessage] = useState("");
  const maxLength = 1000;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled && message.length <= maxLength) {
      onSendMessage(message.trim());
      setMessage("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div className="p-4 bg-white border-t border-gray-200">
      <form onSubmit={handleSubmit} className="flex items-center space-x-3">
        <div className="flex-1">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={disabled ? "Connecting..." : placeholder}
            disabled={disabled}
            maxLength={maxLength}
            className="w-full px-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
          />
          <div className="text-xs text-gray-400 mt-1 text-right">
            <span
              className={message.length > maxLength * 0.9 ? "text-red-500" : ""}
            >
              {message.length}/{maxLength} characters
            </span>
          </div>
        </div>
        <button
          type="submit"
          disabled={disabled || !message.trim() || message.length > maxLength}
          className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Send className="w-5 h-5 text-white" />
        </button>
      </form>
    </div>
  );
};

export default MessageInput;
